// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2BC86","title":"BackImages_title__2KQxL","images":"BackImages_images__13KPm"};